import CaseWidget from './CaseWidget'

export default CaseWidget
